// extracted by mini-css-extract-plugin
export default {"header":"Navigator_header__8u7y+","title":"Navigator_title__rB131","subtitle":"Navigator_subtitle__o7t64"};